module.exports = __webpack_public_path__ + "img/亚奥理事会@2x.23ddb5cc.png";